'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('../../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _text = require('../../text/text');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableCell = function TableCell(_ref) {
  var children = _ref.children,
      dataAttributes = _ref.dataAttributes,
      isInColumnSelection = _ref.isInColumnSelection,
      isInRowSelection = _ref.isInRowSelection,
      isText = _ref.isText,
      style = _ref.style,
      className = _ref.className;

  var classes = (0, _classnames2.default)('table__cell', className, isInColumnSelection && 'table__cell--is-selected', isInRowSelection && 'table__cell--is-in-row-selection');

  return _react2.default.createElement(
    'td',
    _extends({ className: classes, style: style }, dataAttributes),
    isText ? _react2.default.createElement(
      'div',
      { className: 'table__cell-text' },
      _react2.default.createElement(
        _text2.default,
        { truncate: true },
        children
      )
    ) : children
  );
};

TableCell.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  dataAttributes: _propTypes2.default.object,
  isInColumnSelection: _propTypes2.default.bool,
  isInRowSelection: _propTypes2.default.bool,
  isText: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

exports.default = TableCell;